import { Comment } from "../../src/components/insta/interfaces";
import Game from "../../src/shell/Game";
import Question from "../../src/shell/Questions";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { mc } from "../characters/MC";
import { isAnnHate } from "./helpers";
export function getThoughts(imageKey: string) {
    const thoughts: { [key: string]: (string)[]; } = {
        "Alex43": getAlex43(),
        "Alex36": getAlex36(),
        "Alex34": getAlex34(),
        "Alex18": getAlex18(),
        "Alex8": getAlex8(),
        "Ann3": getAnn3(),
        "Ann6": getAnn6(),
        "Ann21": getAnn21(),
        "Ann28": getAnn28(),
    };

    return thoughts[imageKey] || [];

}

const getAlex43 = () => {
    const array: string[] = ["She really posted it!", "I guess my word means something to her."];

    return array;

};
const getAlex36 = () => {
    const array: string[] = ["Woah Alex, calm down..."];

    return array;

};
const getAlex34 = () => {
    const array: string[] = [
        "She seemed so shy and cute in real life, yet so wild on her Insta.",
        "I guess that's what you need to do to make money...",
    ];

    return array;

};
const getAlex18 = () => {
    const array: string[] = ["Alex was at the bar??? I didn't notice her, she must have came after I left.",
    ];

    return array;

};

const getAlex8 = () => {
    const array: string[] = [];
    // if (Game.seenScenarios.includes("AfterTOD")) { return array; }
    if (mc?.properties.annStatus === "natural") {
        if (mc?.properties.metAnn === false) {

            array.push("Alex with a friend.");
            array.push("I wonder who she is.");
        } else {
            array.push("Is that Alex and...Ann?");
            array.push("I should stay on good terms with Ann if I want to get close to Alex!");
        }
    } else {
        array.push("Is that Alex and...Ann?");
        array.push("That means that Alex lives near by!");
        array.push("They must have taken the photo when Ann was on her way here...");
        if (mc.properties.annStatus === "gf") {
            array.push("Ann and I have just started to form our relationship, so asking her details about Alex is out of the question.");
            array.push("For now...");
        } else if (mc.properties.annStatus === "hate") {
            array.push("She seems happy in that photo and I kinda ruined it.");
            array.push("No way she will give me details about Alex now.");
        }
    }
    return array;

};
const getAnn3 = () => {
    const array: string[] = ["Chris must have taken this picture...",
        "I wonder if that was before or after she sucked his dick."
    ];

    return array;

};
const getAnn6 = () => {
    const array: string[] = ["That bastard! I can't believe he met Alex in real life!",
        "I guess that's one of the benefits of dating Ann."
    ];

    return array;

};
const getAnn21 = () => {
    const array: string[] = ["Holy shit!",
        "Speaking on good girls going wild!"
    ];

    return array;

};
const getAnn28 = () => {
    const array: string[] = [
    ];
    if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
        array.push("Now she feels comfortable enough to post photos with Chris to her Insta...");
    } else if (isAnnHate()) {
        array.push("I wonder if Vanessa is right and Ann posts these pics just to try and make me jealous?");

    }

    return array;

};